var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DropdownSelect',{attrs:{"title":"Select shops","items":_vm.shops},model:{value:(_vm.selectedShops),callback:function ($$v) {_vm.selectedShops=$$v},expression:"selectedShops"}})}
var staticRenderFns = []

export { render, staticRenderFns }